import React from 'react';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles({
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center'
  },
  point: {
    width: '34px',
    height: '34px',
    borderRadius: '10px',
    background: '#4B6FC2',
    boxShadow: '0px 6.04444px 10.57778px 0px rgba(62, 107, 224, 0.12)',
    backgroundColor: '#4B6FC2',
    position: 'absolute',
    left: '50%',
    top: '0',
    transform: 'translate(-50%, 10px)',
  },
  line_before: {
    height: 'calc(24px + 12px + 1px)',
    width: '2px',
    backgroundColor: '#4B6FC2',
    position: 'absolute',
    top: '0',
    left: '50%',
    transform: 'translate(-50%, -11px)',
  },
  line_after: {
    position: 'absolute',
    top: '0',
    left: '50%',
    transform: 'translate(-50%, 21px)',
    height: 'calc(100% - 20px + 12px + 1px)',
    width: '2px',
    backgroundColor: '#4B6FC2'
  }
});

const ProgressItemSymbol = ({isFirst, isLast, isPoint = false}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {!isFirst &&
        <div className={classes.line_before} />
      }
      {isPoint &&
        <div className={classes.point} />
      }
      {!isLast &&
        <div className={classes.line_after} />
      }
    </div>
  );
};

export default ProgressItemSymbol;
